module.exports = __webpack_public_path__ + "img/notebook-eleve.36805b91.webp";